<div class="modal">
  <div class="modal-header">
    <div class="modal-heading">
      <h1 class="modal-header-title">Request an Asset</h1>
      <p class="modal-header-subtitle">
        Request an new asset based on your requirement approved by manager
      </p>
    </div>

    <button
      class="modal-header-action"
      type="button"
      (click)="openCloseConfirmationDialog()"
    >
      <img src="assets/24x24/close.svg" alt="" />
    </button>
  </div>
  <div class="modal-body max-height">
    <form class="popup-form" [formGroup]="popupForm">
      <select class="hidden-drop-down" formControlName="location">
        <option value="hidden-select"></option>
      </select>
      <div class="dropdown-wrapper">
        <label class="label">Select Location <span class="required-star">*</span></label>
        <app-generic-drop-down
          [options]="locations"
          title="Select Location"
          (value)="getValue($event, 'location')"
          titleName="locationValue"
          valueName="locationKey"
          [hasCaption]="false"
          [shouldEmitdisplayValue]="true"
        ></app-generic-drop-down>
      </div>
      <select class="hidden-drop-down" formControlName="option">
        <option value="hidden-select"></option>
      </select>
      <div class="dropdown-wrapper">
        <label class="label">Select Asset <span class="required-star">*</span></label>
        <app-generic-drop-down
          [options]="options"
          title="Select Asset Type"
          (value)="getValue($event, 'option')"
          titleName="assetName"
          valueName="assetId"
          [shouldEmitEmittedValue]="true"
        ></app-generic-drop-down>
      </div>
      <label class="label">Describe Your Asset Requirement <span class="required-star">*</span></label>
      <app-textarea
        cols="30"
        rows="10"
        formControlName="description"
        characterCounter
        maxLength="255"
        (countEvent)="displayCount($event)"
        [countData]="countData"
        placeholder="Tell us a little more about the requirement for new asset..."
        [isRequired]="true"
      ></app-textarea>
    </form>
  </div>
</div>
<div class="modal-footer">
  <div class="button">
    <app-button
      class="spacing"
      type="submit"
      [disabled]="popupForm.invalid || isDisable"
      size="xsmall"
      theme="primary"
      (click)="onSubmit()"
      >Submit
    </app-button>
  </div>
</div>
